import React, { Component } from 'react';
import { Tag as OriginTag } from '@tinper/next-ui';
require('./index.less');
const colorsMap = {
    "dark": 'dark',
    "light": 'light',
    "success": 'success',
    "warning": 'warning',
    "danger": 'danger',
    "info": 'info',
    'half-blue': 'half-blue',
    'half-green': 'half-green',
    'half-dark': 'half-dark',
    'half-yellow': 'half-yellow',
    'half-red': 'half-red',
};
export default class Tag extends Component {
    render() {
        let {
            className = '',
            color,
            icon,
            ...others
        } = this.props;
        // 如果color不是这些个背景色 tinper会把字体颜色会变成白色，所以得加个color
        color = colorsMap[color] ? color : 'info';
        let hasIconClassName = icon ? 'base-nc-icon-tag' : '';
        return <OriginTag
            className={`base-nc-tag ${hasIconClassName} ${className}`}
            color={color}
            icon={icon}
            {...others}
        />;
    }
}
